export default {
  component: () => import('./pages/Entry.vue'),
  meta: {
    metaTags: [
      {
        content: 'This report shows you how often you use each tag in your shop, as well as how much competition, search volume, clicks and click through rate (CTR) each tag has.',
        name: 'description',
      },
      {
        page_slug: 'tags',
      },
    ],
    requiresAuth: true,
    title: 'eRank — Tag Report',
  },
  name: 'tags',
  path: '/tags',
};
